
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13208',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13208",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.754",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9943",
  "foundations-components": "static-1.8473",
  "foundations-components-legacy": "static-1.1498",
  "foundations-theming": "static-1.4759",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8318",
  "hub-http-shared-msw-handlers": "static-1.10596",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11778",
  "I18n": "static-7.1670",
  "jasmine-runner": "static-1.6739",
  "marketplace-discovery-studio-lib": "static-1.615",
  "marketplace-storefront-base": "static-1.13271",
  "quartz": "static-1.7441",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17006",
  "reactive-variable-buffer-atom": "static-1.3142",
  "reporting-testing-lib": "static-1.10711",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12812",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7611",
  "ui-addon-i18n": "static-1.11434",
  "ui-addon-react-router-dom": "static-1.9824",
  "unified-auth": "static-1.899",
  "unified-auth-core-lib": "static-1.1181",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8388",
  "hub-http": "static-1.6501",
  "integrations-lib": "static-1.17006",
  "marketplace-ui-common": "static-1.20706",
  "marketplace-ui-install": "static-1.692",
  "property-management-iframe": "static-1.14109",
  "quartz-config": "static-1.1219",
  "quartz-core": "static-1.6660",
  "quartz-routing": "static-1.871",
  "quick-fetch": "static-1.4122",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4954",
  "ts-schema": "static-1.4284",
  "ui-universal-auth": "static-1.9385",
  "UIComponents": "static-3.8724",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3612",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3718",
  "quartz-webpack": "static-1.3665",
  "bend-plugin-quartz-routing": "static-1.519",
  "ai-components-ui-library": "static-1.9690",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5172",
  "pulse": "static-1.916",
  "react-codemirror": "static-1.10926",
  "ui-extensions-preview-lib": "static-1.583",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4742",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2475",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9711",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5547",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2606",
  "ui-fonts": "static-1.1040",
  "ui-images": "static-2.1243",
  "bend-plugin-foundations-theming": "static-1.3242",
  "foundations-theming-base": "static-1.3744",
  "stylex": "static-1.41",
  "HeadJS": "static-2.795",
  "hs-test-utils-bend-plugin": "static-1.3429",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4600",
  "ui-addon-video-player": "static-1.8990",
  "ai-rendering-library": "static-1.11078",
  "chirp-fetch": "static-1.2181",
  "connections-embed-lib": "static-1.1495",
  "copilot-toolkit": "static-1.11829",
  "feedback-loader": "static-1.29794",
  "laboratory-lib": "static-3.7439",
  "marketplace-embed": "static-1.22883",
  "marketplace-ui-details": "static-1.10601",
  "marketplace-ui-reviews": "static-1.20661",
  "marketplace-ui-tracking": "static-1.14876",
  "sanitize-text": "static-1.8441",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7192",
  "quartz-head": "static-1.1106",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4942",
  "immer": "static-1.101",
  "immerable": "static-1.4435",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2677",
  "reporting-data": "static-1.68778",
  "cssUtils": "static-1.907",
  "flux-actions": "static-1.367",
  "react-colorpicker": "static-2.10504",
  "react-dnd-compat": "static-1.4904",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10657",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.681",
  "marketplace-ui-apps-core": "static-1.19238",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4795",
  "foundations-components-test-utils": "static-1.5956",
  "quartz-i18n": "static-1.1116",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.435",
  "ads-unified-auth-lib": "static-1.1314",
  "generic-oauth-auth-lib": "static-1.27",
  "google-sheets-integration-lib": "static-1.1005",
  "microsoft-drive-auth-lib": "static-1.119",
  "surveymonkey-integration-lib": "static-1.457",
  "slack-ui-library": "static-1.10686",
  "fsm": "static-1.4035",
  "customer-data-objects": "static-1.7978",
  "property-translator": "static-1.5683",
  "hs-locale-management": "static-1.285",
  "frontend-preferences-client": "static-1.8211",
  "hs-promise-utils": "static-1.5882",
  "hubspot-apollo-client": "static-1.5164",
  "integrations-error-boundary-lib": "static-1.14421",
  "integrations-tracking-lib": "static-1.5894",
  "native-integrations-shared-strings": "static-1.8064",
  "sanitize": "static-1.4759",
  "superstore": "static-1.5044",
  "ui-shepherd-react": "static-3.10557",
  "ai-settings-ui-library": "static-1.8330",
  "hub-http-janus": "static-1.877",
  "hubspotter-http": "static-1.4856",
  "immutable-less": "static-1.4936",
  "marketplace-ui-client-types": "static-1.18113",
  "nav-meta": "static-1.30442",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18365",
  "ui-product-approvals-common": "static-1.1010",
  "ai-studio-lib": "static-1.12429",
  "hubspot-prosemirror": "static-1.18946",
  "integrations-reconnect-lib": "static-1.468",
  "ui-addon-iframeable": "static-1.9363",
  "ui-addon-integrations-directory-panel": "static-2.8313",
  "ui-product-approvals": "static-1.29115",
  "ui-tool-access": "static-1.10442",
  "inbound-db-properties-service-client": "static-1.4047",
  "property-management-common": "static-1.6397",
  "opentelemetry-fe-types": "static-1.57",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.432",
  "quartz-auth": "static-1.1116",
  "quartz-test": "static-1.1116",
  "quartz-tracking": "static-1.820",
  "trellis-components": "static-1.2625",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.364",
  "HubStyle": "static-2.12085",
  "bender-build-tools": "static-1.3437",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22971",
  "ContentUtils": "static-1.69104",
  "customer-data-objects-ui-components": "static-1.13318",
  "sassPrefix": "static-1.179",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.419",
  "batch-promise": "static-1.1830",
  "event-emitter": "static-1.1240",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5743",
  "magpie-types": "static-1.5203",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1263",
  "avatar-components": "static-1.2767",
  "breeze-engine-core": "static-1.983",
  "breeze-onboarding-components": "static-1.698",
  "customer-data-filters-ui": "static-1.40880",
  "customer-data-reference-ui-components": "static-1.13464",
  "embedded-academy-lib": "static-1.15483",
  "ExportDialog": "static-6.10665",
  "global-styles-ai-lib": "static-1.87",
  "highlight.js": "static-1.86",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42019",
  "reporting-snowflake": "static-1.57395",
  "reporting-ui-components": "static-2.66048",
  "reporting-visualizations": "static-1.60853",
  "trial-components-library": "static-1.14088",
  "ui-addon-teams": "static-1.21894",
  "upgrade-components-lib": "static-1.503",
  "navigation-components": "static-1.18805",
  "breeze-engine-lib": "static-1.1705",
  "simple-logging-lib": "static-1.3338",
  "fail-safe": "static-1.240",
  "app-governance-lib": "static-1.2367",
  "developer-experience-shared-components": "static-1.10796",
  "purchase-motions-components": "static-1.6348",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10215",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3987",
  "reference-resolvers": "static-1.8468",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4205",
  "hubspot-apollo-cache": "static-1.623",
  "universal-page-editor-lib": "static-1.3295",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3510",
  "atom": "static-1.5373",
  "merchandise-lib": "static-1.277",
  "salesImages": "static-1.549",
  "ui-addon-draggable": "static-3.5046",
  "content-assistance-lib": "static-1.8183",
  "content-media-capture": "static-1.5411",
  "customer-data-ui-utilities": "static-1.10116",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24464",
  "growth-payments-core": "static-1.26156",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3181",
  "payment-link-components": "static-1.24147",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20288",
  "ui-addon-emoji-picker": "static-1.10173",
  "ui-business-units-lib": "static-1.9375",
  "video-components-external": "static-1.12128",
  "video-data-lib": "static-1.35786",
  "navigation-messaging": "static-1.8132",
  "collaboration-sidebar": "static-1.58695",
  "crm-component-utils": "static-1.39813",
  "crm-properties-common-lib": "static-1.6176",
  "customer-data-properties": "static-1.52553",
  "external-options-client-types": "static-1.4331",
  "framework-data-schema-resolvers": "static-1.7181",
  "property-value-citations": "static-1.3167",
  "reference-resolvers-lite": "static-1.8389",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10594",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5101",
  "content-icons-ui": "static-1.2350",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1005",
  "breeze-artifacts-sdk": "static-1.295",
  "onboarding-journeys-lib": "static-1.896",
  "onboarding-scopes": "static-1.6741",
  "conversations-skeleton-state": "static-1.7532",
  "crm-message-bus": "static-1.43735",
  "customer-data-filters-ui-msw-helpers": "static-1.23315",
  "events-data-lib": "static-1.531",
  "FormUrlGenerator": "static-2.5014",
  "framework-builder-read-service-client": "static-1.4212",
  "hs-resources": "static-1.479",
  "multi-account-reference-resolvers": "static-1.1291",
  "onboarding-tours": "static-1.17100",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14440",
  "academy-common-lib": "static-1.14943",
  "dashboard-lib": "static-1.82778",
  "getting-started-shared-tasks": "static-1.19215",
  "hubspot-prosemirror-plugins": "static-1.18938",
  "share-with-third-party-component-lib": "static-1.8993",
  "ui-asset-management-lib": "static-1.11385",
  "user-context": "static-1.5407",
  "reporting-plugins": "static-1.10733",
  "reporting-reports": "static-1.68455",
  "hubs-service-types": "static-1.1546",
  "purchase-motions-api": "static-1.6351",
  "signup-constants": "static-1.19605",
  "nest": "static-1.524",
  "breeze-engine-chat-components": "static-1.683",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.191",
  "framework-listing-lib": "static-2.29468",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31403",
  "apps-service-types": "static-1.4026",
  "oauth-service-types": "static-1.4525",
  "signup-ui-url-generator": "static-2.8348",
  "onboarding-tours-client": "static-1.5315",
  "one-click-checkout": "static-1.375",
  "platform-infra-nav-components": "static-1.7884",
  "subscription-experience-data-types": "static-1.15242",
  "crm-record-cards-service-types": "static-1.3777",
  "location-customization-utils-lib": "static-1.10072",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29281",
  "content-media-composition-data-lib": "static-1.13215",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4713",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.697",
  "ui-addon-opt": "static-4.8650",
  "commerce-tours-lib": "static-1.6598",
  "growth-onboarding-reliability": "static-1.5368",
  "sales-checkout-service-client": "static-1.3817",
  "data-token-picker": "static-1.16871",
  "FileManagerLib": "static-1.40104",
  "content-media-compositions": "static-2.17222",
  "media-bridge-lib": "static-1.19389",
  "chatspot-widget-iframe": "static-1.22962",
  "collaboration-sidebar-common": "static-1.3492",
  "marketing-platform-lib": "static-1.7157",
  "card-properties-lib": "static-1.44986",
  "commerce-subscription-lib": "static-1.37752",
  "crm-actions": "static-1.6640",
  "crm-cards-sdk": "static-1.44534",
  "customer-data-properties-shared-msw-handlers": "static-1.9923",
  "customer-data-tracking": "static-1.7169",
  "calling-global-api": "static-1.65572",
  "calling-internal-common": "static-1.31607",
  "calling-lifecycle-internal": "static-1.66954",
  "calling-lifecycle-messages": "static-1.59248",
  "commerce-products-lib": "static-1.10505",
  "conditional-properties-service-client": "static-1.4005",
  "crm-index-visualization-core": "static-1.4525",
  "crm-links": "static-1.6616",
  "crm-pipelines-api-client-types": "static-1.4340",
  "formula-editor": "static-1.14745",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4417",
  "meetings-icalendar-utils-lib": "static-1.923",
  "multi-currency-client-types": "static-1.3900",
  "object-builder-ui-client": "static-1.49645",
  "pipeline-validation-client-types": "static-1.4174",
  "smart-data-capture-core": "static-1.117",
  "smart-property-lib": "static-1.8267",
  "tiered-pricing": "static-1.1934",
  "topics-actions-lib": "static-1.452",
  "ui-addon-form-validation": "static-1.11269",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.300",
  "framework-data-schema-quick-fetch": "static-1.7086",
  "restore-request-side-panel-lib": "static-1.1645",
  "growth-data-modal": "static-1.5878",
  "growth-onboarding-confetti": "static-1.3348",
  "growth-onboarding-next-action-utils": "static-1.2663",
  "onboarding-tours-utils": "static-1.1167",
  "ui-shepherd-tracker": "static-1.7938",
  "academy-service-client": "static-1.3974",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39963",
  "SafeStorage": "static-1.4690",
  "video-embed": "static-1.36620",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.24981",
  "viral-links-lib": "static-1.7363",
  "nested-table": "static-1.521",
  "timezone-utils": "static-2.5531",
  "getting-started-shared-tasks-store": "static-1.18333",
  "campaign-roi-lib": "static-1.10193",
  "campaigns-utils-lib": "static-1.3495",
  "ui-addon-calendars": "static-2.5619",
  "customer-data-views-management": "static-1.25999",
  "framework-data-table": "static-2.12528",
  "nudge-client-utils": "static-1.3137",
  "nudge-custom-ui-functions": "static-1.1473",
  "switchboard-lib": "static-1.503",
  "access-check-ui-lib": "static-1.1558",
  "app-users-service-client": "static-1.5905",
  "app-users-service-types": "static-1.5313",
  "mini-checkout-client": "static-1.27470",
  "onboarding-utils": "static-1.5655",
  "permissions-shared-i18n-strings-fe": "static-1.2120",
  "ui-coaching-tips-shared-config": "static-1.29266",
  "checkout-sdk": "static-3.24313",
  "payment-method-components": "static-1.7137",
  "touchless-buying-components": "static-1.6181",
  "upgrade-catalog-service-types": "static-1.3758",
  "edison-service-client-types": "static-1.680",
  "growth-onboarding-feedback-components": "static-1.6871",
  "audio-components": "static-1.6327",
  "FileManagerImages": "static-1.37615",
  "video-components": "static-1.14130",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92800",
  "customer-data-sidebar": "static-2.46713",
  "enrichment-lib": "static-1.325",
  "ui-addon-draggable-compat": "static-2.4551",
  "universal-record-utils-lib": "static-1.1872",
  "commerce-billing-lib": "static-1.20156",
  "commerce-shared-components-lib": "static-1.19201",
  "commerce-tools-ui-lib": "static-1.11022",
  "crm-fe-perf": "static-1.23189",
  "calling-error-reporting": "static-1.31614",
  "shared-worker-versioning": "static-1.11328",
  "calling-usage-tracker": "static-1.6823",
  "voice-sms-access-library": "static-1.2014",
  "commerce-permissions": "static-1.1064",
  "products-iframe-lib": "static-1.8569",
  "products-ui-components-shared-msw-handlers": "static-1.10978",
  "crm-index-associations-lib": "static-1.6728",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10679",
  "sales-views-client-types": "static-1.4544",
  "bark-lib": "static-1.16800",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.632",
  "policy-lib": "static-1.7088",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10742",
  "onboarding-data-sync-lib": "static-1.2492",
  "growth-onboarding-next-action-components": "static-1.2691",
  "user-context-client": "static-1.4794",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4819",
  "outpost": "static-1.4443",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22139",
  "sales-email-signature-service-client": "static-1.4131",
  "ts-utils-lib": "static-1.436",
  "crm-export-dialog": "static-1.6570",
  "crm-view-components": "static-1.1103",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7613",
  "tasks-actions-lib": "static-1.101",
  "nudge-custom-function-registry": "static-1.2894",
  "nudge-renderer-utils": "static-1.3213",
  "whisper-core-api": "static-1.7299",
  "InboxConnectUtils": "static-4.15535",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46818",
  "hub-http-rxjs": "static-1.841",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4276",
  "company-details-components": "static-1.6489",
  "react-performance-metrics-lib": "static-1.842",
  "pricing-pages-ui-components": "static-1.15770",
  "quote-checkout-service-types": "static-1.3741",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22480",
  "customer-data-email": "static-1.18508",
  "card-payment-highlight-lib": "static-1.37952",
  "commerce-contract-lib": "static-1.13293",
  "invoices-highlight-card-lib": "static-1.55702",
  "orders-highlight-card-lib": "static-1.22171",
  "products-highlight-card-lib": "static-1.18788",
  "quotes-highlight-card-lib": "static-1.72808",
  "crm-source-interpretation-lib": "static-1.5616",
  "data-agent-utils": "static-1.387",
  "crm-object-search-query-utilities": "static-1.10171",
  "utility-belt": "static-1.2819",
  "payments-enrollment-embed-lib": "static-1.23774",
  "stripe-embedded-components": "static-1.7979",
  "customer-data-rte": "static-1.33625",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6255",
  "payments-post-enroll-local-storage-lib": "static-1.5393",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38898",
  "calling-orchestration-schema": "static-1.36791",
  "react-reducer-toolkit": "static-1.16339",
  "meetings-connect-utils-lib": "static-1.7896",
  "hub-http-contrib": "static-1.3325",
  "ui-addon-sales-email": "static-1.5498",
  "access-control-lib": "static-1.10723",
  "EmailComponents": "static-1.55524",
  "EmailData": "static-1.54202",
  "redux-less": "static-2.9765",
  "company-details-service-types": "static-1.4226",
  "segments-query-core": "static-1.1710",
  "pricing-pages-api": "static-1.15635",
  "sequences-lib": "static-1.8514",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41023",
  "accounting-integrations-ui-components": "static-1.7519",
  "invoices-ui-lib": "static-1.55718",
  "commerce-products-api": "static-1.2675",
  "invoices-iframe-lib": "static-1.57776",
  "quotes-modal-lib": "static-1.103486",
  "quotes-ui-lib": "static-1.81529",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28884",
  "ContentComponents": "static-2.72060",
  "ContentData": "static-1.69179",
  "marketing-contacts-lib": "static-1.10994",
  "marketing-email-service-types": "static-1.2082",
  "messaging-editing-lib": "static-1.47106",
  "messaging-usage-based-billing-components-lib": "static-1.1968",
  "automation-ui-source-apps": "static-1.19659",
  "automation-ui-types": "static-1.20577",
  "messaging-types-lib": "static-1.46843",
  "onboarding-settings-client": "static-1.4795",
  "sequences-client-types-lib": "static-1.8371",
  "commerce-tax-lib": "static-1.825",
  "price-books-api": "static-1.1711",
  "price-books-components": "static-1.1769",
  "property-description-translator": "static-1.4126",
  "ramp-editor": "static-1.868",
  "commerce-analytics-service-client": "static-1.3805",
  "totals-ui-components": "static-1.24271",
  "SalesContentIndexUI": "static-3.9609",
  "advanced-menus-core": "static-1.15560",
  "advanced-menus-lib": "static-1.12435",
  "automation-ui-ubb": "static-1.6493",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7623",
  "data-token-views": "static-1.16852",
  "forms-utils-lib": "static-1.13076",
  "payments-embed-points-lib": "static-1.13569",
  "react-tinymce": "static-1.55955",
  "simple-menus-core": "static-1.15559",
  "simple-menus-lib": "static-1.17076",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55081",
  "tinymce-data": "static-1.41166",
  "tinymce-plugins": "static-1.58195",
  "tinymce-themes": "static-1.57051",
  "ui-brand-identity-lib": "static-1.16441",
  "ui-memberships-settings-lib": "static-1.34818",
  "videoconference-integration-components": "static-1.7254",
  "marketing-contacts-client": "static-1.7797",
  "mc-hard-limits-client-types": "static-1.193",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77883",
  "short-messages-app-service-client": "static-1.4202",
  "web-interactives-components": "static-1.14230",
  "web-interactives-data": "static-1.14231",
  "messaging-shared-utils-lib": "static-1.1417",
  "messaging-user-info-utils-lib": "static-1.1587",
  "email-portal-health-service-types": "static-1.1266",
  "line-items-api": "static-1.1078",
  "commerce-totals-service-types": "static-1.4023",
  "FireAlarmUi": "static-1.4712",
  "sales-templates-service-types-lib": "static-1.4376",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22513",
  "automation-ui-usage-tracking": "static-1.21976",
  "data-studio-ubb": "static-1.3484",
  "interframe": "static-3.5042",
  "layout-dnd-components": "static-1.12948",
  "layout-dnd-utils": "static-1.11923",
  "NamespacedHubStyle": "static-2.9255",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27634",
  "content-management-data-lib": "static-1.5936",
  "copilot-plugins": "static-1.11801",
  "cta-picker": "static-1.37061",
  "customer-agent-discovery-components-lib": "static-1.3900",
  "editor-components": "static-1.13632",
  "editor-iframe-lib": "static-1.8781",
  "error-messaging-js": "static-1.5483",
  "FormsCommonComponents": "static-1.86535",
  "layout-data-lib": "static-1.10248",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10937",
  "SharedLegalStrings": "static-1.2034",
  "smart-content-core": "static-1.43150",
  "smart-content-lib": "static-1.43803",
  "social-composer-lib": "static-1.60267",
  "structured-content-lib": "static-1.25894",
  "theme-previewer-lib": "static-1.53922",
  "tinymce-copilot": "static-1.17149",
  "xray-recommendation-lib": "static-1.8248",
  "automation-ui-routing": "static-1.21934",
  "sql-reporting-client-types": "static-1.5885",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42769",
  "reporting-enablement": "static-1.23807",
  "forms-ai-lib": "static-1.4746",
  "codemirror-dlb": "static-1.59442",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6725",
  "report-customization-components": "static-1.13889",
  "data-quality-ui-library": "static-1.13774",
  "reporting-filters": "static-1.982",
  "reporting-insights-lib": "static-1.2545",
  "segments-client-types": "static-1.11492"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13208",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.754",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9943",
  "foundations-components": "/foundations-components/static-1.8473",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1498",
  "foundations-theming": "/foundations-theming/static-1.4759",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8318",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10596",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11778",
  "I18n": "/I18n/static-7.1670",
  "jasmine-runner": "/jasmine-runner/static-1.6739",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.615",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13271",
  "quartz": "/quartz/static-1.7441",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17006",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3142",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10711",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12812",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7611",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11434",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9824",
  "unified-auth": "/unified-auth/static-1.899",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1181",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8388",
  "hub-http": "/hub-http/static-1.6501",
  "integrations-lib": "/integrations-lib/static-1.17006",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20706",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.692",
  "property-management-iframe": "/property-management-iframe/static-1.14109",
  "quartz-config": "/quartz-config/static-1.1219",
  "quartz-core": "/quartz-core/static-1.6660",
  "quartz-routing": "/quartz-routing/static-1.871",
  "quick-fetch": "/quick-fetch/static-1.4122",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4954",
  "ts-schema": "/ts-schema/static-1.4284",
  "ui-universal-auth": "/ui-universal-auth/static-1.9385",
  "UIComponents": "/UIComponents/static-3.8724",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3612",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3718",
  "quartz-webpack": "/quartz-webpack/static-1.3665",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.519",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9690",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5172",
  "pulse": "/pulse/static-1.916",
  "react-codemirror": "/react-codemirror/static-1.10926",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.583",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4742",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2475",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9711",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5547",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2606",
  "ui-fonts": "/ui-fonts/static-1.1040",
  "ui-images": "/ui-images/static-2.1243",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3242",
  "foundations-theming-base": "/foundations-theming-base/static-1.3744",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.795",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3429",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4600",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8990",
  "ai-rendering-library": "/ai-rendering-library/static-1.11078",
  "chirp-fetch": "/chirp-fetch/static-1.2181",
  "connections-embed-lib": "/connections-embed-lib/static-1.1495",
  "copilot-toolkit": "/copilot-toolkit/static-1.11829",
  "feedback-loader": "/feedback-loader/static-1.29794",
  "laboratory-lib": "/laboratory-lib/static-3.7439",
  "marketplace-embed": "/marketplace-embed/static-1.22883",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10601",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20661",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14876",
  "sanitize-text": "/sanitize-text/static-1.8441",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7192",
  "quartz-head": "/quartz-head/static-1.1106",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4942",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4435",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2677",
  "reporting-data": "/reporting-data/static-1.68778",
  "cssUtils": "/cssUtils/static-1.907",
  "flux-actions": "/flux-actions/static-1.367",
  "react-colorpicker": "/react-colorpicker/static-2.10504",
  "react-dnd-compat": "/react-dnd-compat/static-1.4904",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10657",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.681",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19238",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4795",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5956",
  "quartz-i18n": "/quartz-i18n/static-1.1116",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.435",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1314",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.27",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1005",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.119",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.457",
  "slack-ui-library": "/slack-ui-library/static-1.10686",
  "fsm": "/fsm/static-1.4035",
  "customer-data-objects": "/customer-data-objects/static-1.7978",
  "property-translator": "/property-translator/static-1.5683",
  "hs-locale-management": "/hs-locale-management/static-1.285",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8211",
  "hs-promise-utils": "/hs-promise-utils/static-1.5882",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5164",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14421",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5894",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8064",
  "sanitize": "/sanitize/static-1.4759",
  "superstore": "/superstore/static-1.5044",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10557",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8330",
  "hub-http-janus": "/hub-http-janus/static-1.877",
  "hubspotter-http": "/hubspotter-http/static-1.4856",
  "immutable-less": "/immutable-less/static-1.4936",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18113",
  "nav-meta": "/nav-meta/static-1.30442",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18365",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1010",
  "ai-studio-lib": "/ai-studio-lib/static-1.12429",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18946",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.468",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9363",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8313",
  "ui-product-approvals": "/ui-product-approvals/static-1.29115",
  "ui-tool-access": "/ui-tool-access/static-1.10442",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4047",
  "property-management-common": "/property-management-common/static-1.6397",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.57",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.432",
  "quartz-auth": "/quartz-auth/static-1.1116",
  "quartz-test": "/quartz-test/static-1.1116",
  "quartz-tracking": "/quartz-tracking/static-1.820",
  "trellis-components": "/trellis-components/static-1.2625",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.364",
  "HubStyle": "/HubStyle/static-2.12085",
  "bender-build-tools": "/bender-build-tools/static-1.3437",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22971",
  "ContentUtils": "/ContentUtils/static-1.69104",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13318",
  "sassPrefix": "/sassPrefix/static-1.179",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.419",
  "batch-promise": "/batch-promise/static-1.1830",
  "event-emitter": "/event-emitter/static-1.1240",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5743",
  "magpie-types": "/magpie-types/static-1.5203",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1263",
  "avatar-components": "/avatar-components/static-1.2767",
  "breeze-engine-core": "/breeze-engine-core/static-1.983",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.698",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40880",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13464",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15483",
  "ExportDialog": "/ExportDialog/static-6.10665",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.87",
  "highlight.js": "/highlight.js/static-1.86",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42019",
  "reporting-snowflake": "/reporting-snowflake/static-1.57395",
  "reporting-ui-components": "/reporting-ui-components/static-2.66048",
  "reporting-visualizations": "/reporting-visualizations/static-1.60853",
  "trial-components-library": "/trial-components-library/static-1.14088",
  "ui-addon-teams": "/ui-addon-teams/static-1.21894",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.503",
  "navigation-components": "/navigation-components/static-1.18805",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1705",
  "simple-logging-lib": "/simple-logging-lib/static-1.3338",
  "fail-safe": "/fail-safe/static-1.240",
  "app-governance-lib": "/app-governance-lib/static-1.2367",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10796",
  "purchase-motions-components": "/purchase-motions-components/static-1.6348",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10215",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3987",
  "reference-resolvers": "/reference-resolvers/static-1.8468",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4205",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.623",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3295",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3510",
  "atom": "/atom/static-1.5373",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "salesImages": "/salesImages/static-1.549",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5046",
  "content-assistance-lib": "/content-assistance-lib/static-1.8183",
  "content-media-capture": "/content-media-capture/static-1.5411",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10116",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24464",
  "growth-payments-core": "/growth-payments-core/static-1.26156",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3181",
  "payment-link-components": "/payment-link-components/static-1.24147",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20288",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10173",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9375",
  "video-components-external": "/video-components-external/static-1.12128",
  "video-data-lib": "/video-data-lib/static-1.35786",
  "navigation-messaging": "/navigation-messaging/static-1.8132",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58695",
  "crm-component-utils": "/crm-component-utils/static-1.39813",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6176",
  "customer-data-properties": "/customer-data-properties/static-1.52553",
  "external-options-client-types": "/external-options-client-types/static-1.4331",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7181",
  "property-value-citations": "/property-value-citations/static-1.3167",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8389",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10594",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5101",
  "content-icons-ui": "/content-icons-ui/static-1.2350",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1005",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.295",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.896",
  "onboarding-scopes": "/onboarding-scopes/static-1.6741",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7532",
  "crm-message-bus": "/crm-message-bus/static-1.43735",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23315",
  "events-data-lib": "/events-data-lib/static-1.531",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5014",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4212",
  "hs-resources": "/hs-resources/static-1.479",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1291",
  "onboarding-tours": "/onboarding-tours/static-1.17100",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14440",
  "academy-common-lib": "/academy-common-lib/static-1.14943",
  "dashboard-lib": "/dashboard-lib/static-1.82778",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19215",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18938",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8993",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11385",
  "user-context": "/user-context/static-1.5407",
  "reporting-plugins": "/reporting-plugins/static-1.10733",
  "reporting-reports": "/reporting-reports/static-1.68455",
  "hubs-service-types": "/hubs-service-types/static-1.1546",
  "purchase-motions-api": "/purchase-motions-api/static-1.6351",
  "signup-constants": "/signup-constants/static-1.19605",
  "nest": "/nest/static-1.524",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.683",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.191",
  "framework-listing-lib": "/framework-listing-lib/static-2.29468",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31403",
  "apps-service-types": "/apps-service-types/static-1.4026",
  "oauth-service-types": "/oauth-service-types/static-1.4525",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8348",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5315",
  "one-click-checkout": "/one-click-checkout/static-1.375",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7884",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15242",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3777",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10072",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29281",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13215",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4713",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.697",
  "ui-addon-opt": "/ui-addon-opt/static-4.8650",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6598",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5368",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3817",
  "data-token-picker": "/data-token-picker/static-1.16871",
  "FileManagerLib": "/FileManagerLib/static-1.40104",
  "content-media-compositions": "/content-media-compositions/static-2.17222",
  "media-bridge-lib": "/media-bridge-lib/static-1.19389",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22962",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3492",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7157",
  "card-properties-lib": "/card-properties-lib/static-1.44986",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37752",
  "crm-actions": "/crm-actions/static-1.6640",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44534",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9923",
  "customer-data-tracking": "/customer-data-tracking/static-1.7169",
  "calling-global-api": "/calling-global-api/static-1.65572",
  "calling-internal-common": "/calling-internal-common/static-1.31607",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66954",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59248",
  "commerce-products-lib": "/commerce-products-lib/static-1.10505",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4005",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4525",
  "crm-links": "/crm-links/static-1.6616",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4340",
  "formula-editor": "/formula-editor/static-1.14745",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4417",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.923",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3900",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49645",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4174",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.117",
  "smart-property-lib": "/smart-property-lib/static-1.8267",
  "tiered-pricing": "/tiered-pricing/static-1.1934",
  "topics-actions-lib": "/topics-actions-lib/static-1.452",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11269",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.300",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7086",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1645",
  "growth-data-modal": "/growth-data-modal/static-1.5878",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3348",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2663",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1167",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7938",
  "academy-service-client": "/academy-service-client/static-1.3974",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39963",
  "SafeStorage": "/SafeStorage/static-1.4690",
  "video-embed": "/video-embed/static-1.36620",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24981",
  "viral-links-lib": "/viral-links-lib/static-1.7363",
  "nested-table": "/nested-table/static-1.521",
  "timezone-utils": "/timezone-utils/static-2.5531",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18333",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10193",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3495",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5619",
  "customer-data-views-management": "/customer-data-views-management/static-1.25999",
  "framework-data-table": "/framework-data-table/static-2.12528",
  "nudge-client-utils": "/nudge-client-utils/static-1.3137",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1473",
  "switchboard-lib": "/switchboard-lib/static-1.503",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1558",
  "app-users-service-client": "/app-users-service-client/static-1.5905",
  "app-users-service-types": "/app-users-service-types/static-1.5313",
  "mini-checkout-client": "/mini-checkout-client/static-1.27470",
  "onboarding-utils": "/onboarding-utils/static-1.5655",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2120",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29266",
  "checkout-sdk": "/checkout-sdk/static-3.24313",
  "payment-method-components": "/payment-method-components/static-1.7137",
  "touchless-buying-components": "/touchless-buying-components/static-1.6181",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3758",
  "edison-service-client-types": "/edison-service-client-types/static-1.680",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6871",
  "audio-components": "/audio-components/static-1.6327",
  "FileManagerImages": "/FileManagerImages/static-1.37615",
  "video-components": "/video-components/static-1.14130",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92800",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46713",
  "enrichment-lib": "/enrichment-lib/static-1.325",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4551",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1872",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20156",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19201",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11022",
  "crm-fe-perf": "/crm-fe-perf/static-1.23189",
  "calling-error-reporting": "/calling-error-reporting/static-1.31614",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11328",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6823",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2014",
  "commerce-permissions": "/commerce-permissions/static-1.1064",
  "products-iframe-lib": "/products-iframe-lib/static-1.8569",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10978",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6728",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10679",
  "sales-views-client-types": "/sales-views-client-types/static-1.4544",
  "bark-lib": "/bark-lib/static-1.16800",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.632",
  "policy-lib": "/policy-lib/static-1.7088",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10742",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2492",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2691",
  "user-context-client": "/user-context-client/static-1.4794",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4819",
  "outpost": "/outpost/static-1.4443",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22139",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4131",
  "ts-utils-lib": "/ts-utils-lib/static-1.436",
  "crm-export-dialog": "/crm-export-dialog/static-1.6570",
  "crm-view-components": "/crm-view-components/static-1.1103",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7613",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.101",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2894",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3213",
  "whisper-core-api": "/whisper-core-api/static-1.7299",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15535",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46818",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.841",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4276",
  "company-details-components": "/company-details-components/static-1.6489",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.842",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15770",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3741",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22480",
  "customer-data-email": "/customer-data-email/static-1.18508",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37952",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13293",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55702",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22171",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18788",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72808",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5616",
  "data-agent-utils": "/data-agent-utils/static-1.387",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10171",
  "utility-belt": "/utility-belt/static-1.2819",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23774",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7979",
  "customer-data-rte": "/customer-data-rte/static-1.33625",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6255",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5393",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38898",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36791",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16339",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7896",
  "hub-http-contrib": "/hub-http-contrib/static-1.3325",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5498",
  "access-control-lib": "/access-control-lib/static-1.10723",
  "EmailComponents": "/EmailComponents/static-1.55524",
  "EmailData": "/EmailData/static-1.54202",
  "redux-less": "/redux-less/static-2.9765",
  "company-details-service-types": "/company-details-service-types/static-1.4226",
  "segments-query-core": "/segments-query-core/static-1.1710",
  "pricing-pages-api": "/pricing-pages-api/static-1.15635",
  "sequences-lib": "/sequences-lib/static-1.8514",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41023",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7519",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55718",
  "commerce-products-api": "/commerce-products-api/static-1.2675",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57776",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103486",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81529",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28884",
  "ContentComponents": "/ContentComponents/static-2.72060",
  "ContentData": "/ContentData/static-1.69179",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10994",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2082",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47106",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1968",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19659",
  "automation-ui-types": "/automation-ui-types/static-1.20577",
  "messaging-types-lib": "/messaging-types-lib/static-1.46843",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4795",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8371",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.825",
  "price-books-api": "/price-books-api/static-1.1711",
  "price-books-components": "/price-books-components/static-1.1769",
  "property-description-translator": "/property-description-translator/static-1.4126",
  "ramp-editor": "/ramp-editor/static-1.868",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3805",
  "totals-ui-components": "/totals-ui-components/static-1.24271",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9609",
  "advanced-menus-core": "/advanced-menus-core/static-1.15560",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12435",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6493",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7623",
  "data-token-views": "/data-token-views/static-1.16852",
  "forms-utils-lib": "/forms-utils-lib/static-1.13076",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13569",
  "react-tinymce": "/react-tinymce/static-1.55955",
  "simple-menus-core": "/simple-menus-core/static-1.15559",
  "simple-menus-lib": "/simple-menus-lib/static-1.17076",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55081",
  "tinymce-data": "/tinymce-data/static-1.41166",
  "tinymce-plugins": "/tinymce-plugins/static-1.58195",
  "tinymce-themes": "/tinymce-themes/static-1.57051",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16441",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34818",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7254",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7797",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.193",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77883",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4202",
  "web-interactives-components": "/web-interactives-components/static-1.14230",
  "web-interactives-data": "/web-interactives-data/static-1.14231",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1417",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1587",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1266",
  "line-items-api": "/line-items-api/static-1.1078",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4023",
  "FireAlarmUi": "/FireAlarmUi/static-1.4712",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4376",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22513",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21976",
  "data-studio-ubb": "/data-studio-ubb/static-1.3484",
  "interframe": "/interframe/static-3.5042",
  "layout-dnd-components": "/layout-dnd-components/static-1.12948",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11923",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9255",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27634",
  "content-management-data-lib": "/content-management-data-lib/static-1.5936",
  "copilot-plugins": "/copilot-plugins/static-1.11801",
  "cta-picker": "/cta-picker/static-1.37061",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3900",
  "editor-components": "/editor-components/static-1.13632",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8781",
  "error-messaging-js": "/error-messaging-js/static-1.5483",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86535",
  "layout-data-lib": "/layout-data-lib/static-1.10248",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10937",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2034",
  "smart-content-core": "/smart-content-core/static-1.43150",
  "smart-content-lib": "/smart-content-lib/static-1.43803",
  "social-composer-lib": "/social-composer-lib/static-1.60267",
  "structured-content-lib": "/structured-content-lib/static-1.25894",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53922",
  "tinymce-copilot": "/tinymce-copilot/static-1.17149",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8248",
  "automation-ui-routing": "/automation-ui-routing/static-1.21934",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5885",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42769",
  "reporting-enablement": "/reporting-enablement/static-1.23807",
  "forms-ai-lib": "/forms-ai-lib/static-1.4746",
  "codemirror-dlb": "/codemirror-dlb/static-1.59442",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6725",
  "report-customization-components": "/report-customization-components/static-1.13889",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13774",
  "reporting-filters": "/reporting-filters/static-1.982",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2545",
  "segments-client-types": "/segments-client-types/static-1.11492"
}
};
